export const EquipmentSummaryFactory = () => {
    return function EquipmentSummary() {
        this.id = null;
        this.name = null;
        this.count = 0;
        this.department = null;
    };
};
